<template>
  <div>
    <!-- Modificatore della variabile act-for per richiedere dati di altre aziende -->
    <!-- associate al referente aziendale -->
    <SwitcherAziende />

    <PageTagline :is_ref_azi_area="true" :elements="tagline_elem" />

    <!-- accordion con descrizione funzionamento del tool e compilazione del file -->
    <div class="accordion" role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-1 variant="primary" class="text-left">
            <b-icon icon="info-circle" class="mr-2"></b-icon>
            Informazioni file da importare
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>
              <b>CAMPI OBBLIGATORI:</b>
              <ul>
                <li><b>Email:</b> tutte le mail devono essere diverse</li>
                <li><b>Password:</b> NON COMPILARE</li>
                <li><b>Cognome:</b> inserire i dati del beneficiario del PWA</li>
                <li><b>Nome:</b> inserire i dati del beneficiario del PWA</li>
                <li><b>Codice Fiscale:</b> inserire i dati del beneficiario del PWA</li>
                <li><b>Tipo contratto:</b> terminologie ammesse: Tempo indeterminato, Tempo determinato</li>
                <li><b>Inquadramento:</b> terminologie ammesse: Amministratore, Dirigente, Impiegato, Interinale, Stagista, Quadro, Operaio, Collaboratore</li>
                <li><b>Impiegato dal:</b> inserire i dati del beneficiario del PWA</li>
                <li><b>Impiegato al:</b> inserire i dati del beneficiario del PWA</li>
                <li><b>Welfare Totale:</b> se NON è previsto incremento di credito inserire 0.00</li>
                <li>
                  <b>Welfare art51c3:</b> da compilare per tutti in base all'importo massimo spendibile (LEGGE 213/23 - LEGGE DI BILANCIO 2024). 
                  <div><b>1000.00</b> per chi non ha figli a carico, <b>2000.00</b> per chi ha figli a carico</div>
                  <i>NB:</i> Qualsiasi importo inserito in Welfare Totale o Welfare art51c3 viene sommato a quelli già presenti in portale.
                </li>
                <li><b>Decorrenza:</b> Data in cui verrà reso disponibile il credito</li>
                <li><b>Scadenza:</b> Data di scadenza del credito</li>
                <li>
                  <b>Tipo fonte:</b> <b>1</b> (Welfare puro CCNL), <b>2</b> (Welfare puro da regolamento), <b>3</b> (Welfare puro CCA), <b>4</b> (Welfare da conversione PDR - CCA), <b>5</b> (Welfare da conversione PDR - CCT), <b>6</b> (Welfare puro da regolamento non vincolante/volontario), <b>7</b> (Indicazione art51c3)
                </li>
              </ul>
            </b-card-text>
            <b-card-text></b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>

    <b-card>
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <h4 class="mb-0">Import Caricamento Tracciato</h4>
          <div>
            <!-- Link manuale pdf -->
            <b-link class="mr-2" target="_blank" href="https://userportal.welfarebit.it/media/docs/guida_tracciato_crediti_csv_rev02.pdf"><b-icon icon="cloud-download"></b-icon>  Manuale</b-link>
            <!-- Bottone per scaricare il file template -->
             <b-button variant="primary" size="sm" class="mr-2" @click="downloadTemplate">
              <b-icon icon="download" class="mr-1"></b-icon>
              Template
            </b-button>
            <!-- Bottone per aprire il modal di upload -->
            <b-button v-b-modal.upload-modal variant="primary" size="sm" class="mr-2" :disabled="uploading">
              <b-icon icon="upload" class="mr-1"></b-icon>
              Carica File
            </b-button>
            <!-- Bottone per refreshare i dati della tabella -->
            <b-button size="sm" @click="refreshTable">
              <b-icon icon="arrow-clockwise" />
            </b-button>
          </div>
        </div>
      </template>
      <b-card-body>
        <b-table
          ref="importTable"
          :items="fetchData"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :busy.sync="isBusy"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @update:sortBy="fetchData"
          @update:sortDesc="fetchData"
        >
          <template #table-busy>
            <div class="text-center text-muted my-2">
              <b-spinner small />
              Caricamento dati...
            </div>
          </template>
          <template #cell(input_filename)="data">
            <a href="#" @click.prevent="downloadFile(data.item.id, data.value, 'input')">{{ data.value }}</a>
          </template>
          <template #cell(output_filename)="data">
            <a href="#" @click.prevent="downloadFile(data.item.id, data.value, 'output')">{{ data.value }}</a>
          </template>
          <template #cell(status)="data">
            <b-badge :variant="resolveStatusBadge(data.value).variant">
              {{ resolveStatusBadge(data.value).text }}
            </b-badge>
          </template>
          <template #cell(note)="data">
            <b-button v-if="isValidNote(data.value)" size="sm" @click="showNoteModal(data.value)">
              Visualizza
            </b-button>
          </template>
          <template #cell(actions)="data">
            <b-button
              v-if="data.item.status === 'VALIDATION_COMPLETED'"
              variant="danger"
              size="sm"
              @click="cancelImport(data.item.id)"
            >
              <b-icon icon="trash" />
              Annulla
            </b-button>
          </template>
        </b-table>
        <!-- <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" @change="fetchData" /> -->
      </b-card-body>
    </b-card>

    <!-- Modal per l'upload del file -->
    <b-modal id="upload-modal" title="Carica file di importazione" hide-footer>
      <b-form-group
        label="File da importare"
        label-for="file-input"
        :invalid-feedback="!csvfile ? 'Seleziona un file!' : ''"
        :state="!!csvfile"
      >
        <b-form-file
          id="file-input"
          :disabled="uploading"
          v-model="csvfile"
          :state="!!csvfile"
          accept=".xlsx,.xls"
          placeholder="Scegli un file o trascinalo qui..."
          drop-placeholder="Rilascia qui il file..."
        ></b-form-file>
      </b-form-group>

      <div class="d-flex justify-content-end mt-4">
        <b-button variant="outline-secondary" class="mr-2" @click="$bvModal.hide('upload-modal')" :disabled="uploading">
          Annulla
        </b-button>
        <b-overlay :show="uploading" rounded opacity="0.6" spinner-small spinner-variant="primary" class="d-inline-block">
          <b-button :disabled="!csvfile || uploading" variant="primary" @click="carica_ordine()">
            <b-icon icon="upload"></b-icon>
            Carica
          </b-button>
        </b-overlay>
      </div>
    </b-modal>

    <!-- Modal per visualizzare la nota -->
    <b-modal id="note-modal" title="Dettaglio Nota" hide-footer>
      <p v-if="selectedNote" style="background-color: #FFFF88;padding: 10px;border-radius: 5px;">{{ selectedNote }}</p>
    </b-modal>
  </div>
</template>

<script>
import { apiUrl } from "@/apiUrl";
import PageTagline from "@/components/PageTagline";
import SwitcherAziende from "@/components/refaziendale/SwitcherAziende.vue";
import axios from "axios";

export default {
  name: "ImportTool",
  data() {
    return {
      tagline_elem: [{ text: "Import Caricamento Tracciato", link: "office-import-anagrafiche-crediti" }],

      // uploading status
      uploading: false,

      // File csv da caricare per l'ordine
      csvfile: null,

      // nota selezionata
      selectedNote: null,

      // table stuff
      fields: [
        { key: "id", sortable: false },
        { key: "status", sortable: false, label: "Stato" },
        { key: "input_filename", sortable: false, label: "Input File" },
        { key: "output_filename", sortable: false, label: "Output File" },
        { key: "note", sortable: false, label: "Note" },
        { key: "actions", label: "Azione", sortable: false }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      sortBy: "",
      sortDesc: false,
      isBusy: false
    };
  },
  methods: {
    cancelImport(importId) {
      this.$bvModal
        .msgBoxConfirm("Sei sicuro di voler annullare questo import?", {
          title: "Conferma annullamento",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Sì, annulla",
          cancelTitle: "No",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            axios
              .post(apiUrl.importtoolapi.cancel_import.replace("@import_id", importId))
              .then(() => {
                this.$bvToast.toast("Import annullato con successo.", {
                  title: "Successo",
                  variant: "success",
                  solid: true
                });
                this.refreshTable();
              })
              .catch(err => {
                console.error(err);
                this.$bvToast.toast("Errore durante l'annullamento dell'import.", {
                  title: "Errore",
                  variant: "danger",
                  solid: true
                });
              });
          }
        });
    },
    resolveStatusBadge(status) {
      switch (status) {
        case "IN_QUEUE":
          return { text: "In Coda", variant: "info" };
        case "IN_PROGRESS":
          return { text: "In Lavorazione", variant: "primary" };
        case "VALIDATION_FAILED":
          return { text: "Errori di Validazione", variant: "danger" };
        case "VALIDATION_COMPLETED":
          return { text: "Validazione Completata", variant: "success" };
        case "VALIDATION_COMPLETED_WITH_WARNINGS":
          return { text: "Validazione Completata (Con Anomalie)", variant: "warning" };
        case 'CANCELLED_BY_COMPANY_REFERENT':
          return { text: "Annullato", variant: "info" };
        case "REJECTED_BY_BACKOFFICE":
          return { text: "Rifiutato dal Backoffice", variant: "warning" };
        case "ACCEPTED_BY_BACKOFFICE":
          return { text: "Accettato dal Backoffice", variant: "success" };
        case "IMPORTED_SUCCESSFULLY":
          return { text: "Accettato dal Backoffice", variant: "success" };
        case "IMPORT_FAILED":
          return { text: "Accettato dal Backoffice", variant: "danger" };
        default:
          return { text: status, variant: "secondary" };
      }
    },
    refreshTable() {
      this.$refs.importTable.refresh();
    },
    showNoteModal(note) {
      this.selectedNote = note;
      this.$bvModal.show("note-modal");
    },
    isValidNote(note) {
      return note && note.length > 0
    },
    carica_ordine: function() {
      const self = this;

      let form_data = new FormData();

      if (this.csvfile === null) {
        form_data.append("csv_ordine", "");
      } else {
        form_data.append("csv_ordine", this.csvfile);
      }

      self.uploading = true;
      axios
        .post(apiUrl.importtoolapi.importtools, form_data, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(() => {
          this.$bvModal.hide("upload-modal");
          this.$bvToast.toast("File importato con successo!", {
            title: "Importazione completata",
            variant: "success",
            solid: true
          });
          this.refreshTable();
        })
        .catch(err => {
          console.error(err);
          this.$bvToast.toast("Errore durante l'importazione del file.", {
            title: "Errore",
            variant: "danger",
            solid: true
          });
        })
        .finally(() => {
          self.uploading = false;
          self.csvfile = null;
        });
    },
    downloadFile(pk, filename, type) {
      axios({
        url: `${apiUrl.importtoolapi.importtools}${pk}/download/${type}/`,
        method: "GET",
        responseType: "blob"
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(err => {
          this.$bvToast.toast("Impossibile scaricare il file.", {
            title: "Errore",
            variant: "danger",
            solid: true
          });
        });
    },
    async fetchData(ctx) {
      this.isBusy = true;
      const { currentPage, perPage, sortBy, sortDesc } = this;
      try {
        const data = await axios.get(apiUrl.importtoolapi.importtools).then(res => res.data);
        this.totalRows = data.length;
        return data;
      } catch (e) {
        console.error(e);
        return [];
      } finally {
        this.isBusy = false;
      }
    },
    downloadTemplate() {
      const filename = "template.xlsx"; // nome file fisso

      axios({
        url: `${apiUrl.importtoolapi.importtools}template/download/`,
        method: "GET",
        responseType: "blob"
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(err => {
          console.error(err);
          this.$bvToast.toast("Impossibile scaricare il file.", {
            title: "Errore",
            variant: "danger",
            solid: true
          });
        });
    }
  },
  components: {
    PageTagline,
    SwitcherAziende
  }
};
</script>

<style scoped>
/* Classe  */
table :deep(.keycell) {
  max-width: 600px;
}
</style>
